module.exports = __webpack_public_path__ + "img/bot_yf2.8722980d.png";